<div class="registro div-expand" [ngClass]="{'print-page':print}">
  <h3>Demandas de Monitoramento</h3>
  <div class="system-table">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th class="title">Código</th>
            <th class="">Item Monitorado</th>
            <th class="">Título</th>
            <th class="">Andamento</th>
            <th class="">Situação</th>
            <th class="">Prazo</th>
            <th class="">Solicitante</th>
            <th class="">Atribuido para</th>
            <th class="">Alterado em</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let demand of data">
            <tr>
              <td>{{demand?.id}}</td>
              <td>{{demand?.ac_label}}</td>
              <td>{{demand?.subject}}</td>
              <td>{{demand?.mf_issue_sub_stat?.name}}</td>
              <td class="text-center">
                <div class="issue-status issue-status-{{demand?.status1 ?? 0}}"></div>
                <strong>
                  <br/>{{demand?.mf_issue_stat?.name}}
                </strong>
              </td>
              <td>{{demand?.dt_foreseen_end | date: 'dd/MM/YYYY':'UTC'}}</td>
              <td>{{demand?.tb_pss_pessoa_ctr_inc?.str_nome}}</td>
              <td>{{demand?.mf_issue_defendant?.tb_pss_pessoa?.str_nome}}</td>
              <td>{{demand?.ctr_dth_atu | date: 'dd/MM/YYYY H:mm:s':'UTC'}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>